import JSEncrypt from 'jsencrypt';
import { CERTIFICATE_PUB, FIAT_PAYMENT_CERTIFICATE_PUB } from '../security/certificate';
import { AvatarGenerator } from 'random-avatar-generator';
import { Link } from 'react-router-dom';

const jsEncrypt = new JSEncrypt();
jsEncrypt.setPublicKey(CERTIFICATE_PUB);

const fiatJSEncrypt = new JSEncrypt();
fiatJSEncrypt.setPublicKey(FIAT_PAYMENT_CERTIFICATE_PUB);

export function isAuthRoute(location) {
    return location === '/login' || location === '/signup' || location === '/forget-credential' || location === '/update-password';
}

export function isItemDetailSection(location) {
    try {
        return location.split('/')[1] === 'detail';
    } catch (e) { return false; }
}

export function encrypt(message) {
    return message;
    // if (typeof message === 'object') return { data: jsEncrypt.encrypt(JSON.stringify(message)) };
    // else return jsEncrypt.encrypt(message);
}

export function encryptFiatPaymentData(message) {
    if (typeof message === 'object') return fiatJSEncrypt.encrypt(JSON.stringify(message)).toString();
    else return fiatJSEncrypt.encrypt(message);
}

export function validateEmail(email = '') {
    return /^(([^<>()[\]\\.,;:\s@"](\.[^<>()[\]\\.,;:\s@"])*)|("."))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]\.)[a-zA-Z]{2,}))$/.test(email.toLowerCase());
}

export function validatePhoneNumber(phone) {
    return /1?\W*([2-9][0-8][0-9])\W*([2-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/.test(phone);
}

export function validateWebsite(website) {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
    return regex.test(website.trim());
}

export function validatedNumber(value) {
    return /^(?=.)([-]?([0-9]*)(\.([0-9]))?)$/.test(value);
}

export function cleanObject(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj
}

export function isVideo(type) {
    return RegExp('video|VIDEO|mp4|MP4|MOV|mov').test(type);
}

export function onlyAdmins(username) {
    return username === 'luaymm' || username === 'hussfaraj';
}

export function parseQueryParamsToObject(query) {

    if (!query) return {};

    query = query.replace('?', '');
    query = query.split('&');

    let object = {};

    for (let param of query) {
        const [key, value] = param.split('=');
        object[key] = value;
    }
    return object;
}






export function errorMessageHandler(err) {
    const defaultMessage = "An unexpected error occurred. Please try again later.";

    try {
        if (!err) return defaultMessage;

        // Handle network error
        if (err.message === "Network Error") return defaultMessage;

        // Handle backend response error
        const backendMessage = err?.response?.data?.errors?.[0]?.message;
        if (backendMessage) return backendMessage;

        // Use error message if available
        if (err.message) return err.message;

        return defaultMessage;
    } catch {
        return defaultMessage;
    }
}



export function hasProfileChanged(profile, editProfile) {
    if (!editProfile) return false;

    const mapping = {
        display_name: "display_name",
        custom_url: "custom_url",
        twitter_username: "twitter_username",
        site_or_portfolio: "site_or_portfolio"
    };

    if (!profile) {
        return Object.keys(editProfile).some(key => {
            const value = editProfile[key];
            return value !== null && value !== "";
        });
    }

    const fieldsChanged = Object.keys(mapping).some(key => {
        const profileKey = mapping[key];
        const original = profile[profileKey] ?? "";
        const updated = editProfile[key] ?? "";
        return original !== updated;
    });

    return fieldsChanged;
}

export function formatTime(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes} minutes ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hours ago`;
    const days = Math.floor(hours / 24);
    return `${days} days ago`;
};

export function fetchUserProfileImage(fileName) {
   
    if (fileName) {
        return `${process.env.REACT_APP_IMAGE_URL}/profile/personalImage/${fileName}`
    }
    else {
        // let generator = new AvatarGenerator();
        // return generator.generateRandomAvatar()
        return '/images/default-avatar.svg'
    }

};

export function fetchNftImage(fileName) {

    return `${process.env.REACT_APP_IMAGE_URL}/images/${fileName}`
};
export function randomAwatarGenerator() {
    let generator = new AvatarGenerator();
    return generator.generateRandomAvatar()

};

export function SpinnerLoader() {
    return (
        <div className="d-flex align-items-center justify-content-center w-100 h-100">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export function ButtonSpinner() {
    return (
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    )
}



// export function fetchHistoryDetail(action, price = 0, to_user_details, from_user_details) {
//     if (action === 'listed')
//         return `${from_user_details.first_name} listed this NFT for sale at ${price} NUC 💰`;

//     if (action === 'minted')
//         return `✨ Minted and created by ${to_user_details.first_name}`;

//     if (action === 'transferred')
//         return `🔁 Transferred from ${from_user_details.first_name} to ${to_user_details.first_name}`;

//     if (action === 'sold')
//         return `💎 Purchased by ${to_user_details.first_name} from ${from_user_details.first_name} for ${price} NUC`;

//     if (action === 'cancel')
//         return `🚫 Listing cancelled by ${from_user_details.first_name}`;

//     return `ℹ️ Unknown action: ${action}`;
// }


export function fetchHistoryDetail(action, price = 0, to_user, from_user) {
    if (action === 'listed')
        return (
            <>
                <Link to={`/profile/${from_user.user_name}`}>{from_user.first_name}</Link> listed this NFT for sale at {price} NUC 💰
            </>
        );

    if (action === 'minted')
        return (
            <>
                ✨ Minted and created by{" "}
                <Link to={`/profile/${to_user.user_name}`}>{to_user.first_name}</Link>
            </>
        );

    if (action === 'transferred')
        return (
            <>
                🔁 Transferred from{" "}
                <Link to={`/profile/${from_user.user_name}`}>{from_user.first_name}</Link>{" "}
                to{" "}
                <Link to={`/profile/${to_user.user_name}`}>{to_user.first_name}</Link>
            </>
        );

    if (action === 'sold')
        return (
            <>
                💎 Purchased by{" "}
                <Link to={`/profile/${to_user.user_name}`}>{to_user.first_name}</Link>{" "}
                from{" "}
                <Link to={`/profile/${from_user.user_name}`}>{from_user.first_name}</Link>{" "}
                for {price} NUC
            </>
        );

    if (action === 'cancel')
        return (
            <>
                🚫 Listing cancelled by{" "}
                <Link to={`/profile/${from_user.user_name}`}>{from_user.first_name}</Link>
            </>
        );

    return <>ℹ️ Unknown action: {action}</>;
}




export function fetchNftownerDetail(action, to_user_details, from_user_details) {

    
    if (action === 'minted') return `${to_user_details.first_name}`
    if (action === 'transferred') return `${to_user_details.first_name}`
    if (action === 'sold') return `${to_user_details.first_name}`
    // From Bob to Alice
}


export function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}




export const getVideoUrl = (filePath) => {
   
    if (!filePath) return "/images/placeholder.png";
    return `${process.env.REACT_APP_IMAGE_URL}/videos/${filePath}`;
};

export const clickWhenReady = (id) => {
    return new Promise(resolve => {
        let tries = 0;
        const interval = setInterval(() => {
            const el = document.getElementById(id);
            if (el) {
                clearInterval(interval);
                el.click();
                resolve(true);
            }
            tries++;
            if (tries > 20) { // 20 x 50ms = 1 second timeout
                clearInterval(interval);
                console.error("Element not found:", id);
                resolve(false);
            }
        }, 50);
    });
}
